import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M19.304 5.74a8 8 0 0 0-.156 1.617 7.86 7.86 0 0 0 4.591 7.139c.17-.806.261-1.64.261-2.496 0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c4.11 0 7.737-2.067 9.9-5.217H6.783v-1.566h16.026q.247-.509.445-1.043H6.783z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "m8.816 6.261.259.797h.838l-.678.493.26.797-.679-.493-.678.493.259-.797-.678-.493h.838zM5.41 12l.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048zM5.41 3.652l.324.997h1.048l-.848.616.324.996-.848-.616-.847.616.324-.996-.848-.616h1.048zM2.801 8.347l.324.997h1.048l-.848.616.324.996-.848-.616-.847.616.323-.996-.847-.616h1.047z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }